module.exports = __webpack_public_path__ + "img/tm.ab14830f.svg";